<template>
  <div class="role-manage">
    <!-- 角色管理 -->
    <div class="filter-container">
      <!-- 查找参数区 -->
      <el-form :model="listQuery" :inline="true">
        <el-form-item label="角色名称:">
          <el-input placeholder="请输入角色名称" v-model="listQuery.params.name" style="width: 200px" class="filter-item"
            maxlength="20" onkeyup="this.value=this.value.replace(/[^a-zA-Z\u4e00-\u9fa5]+$/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="所属单位:">
          <el-select v-model="listQuery.entityId" placeholder="请选择所属单位" style="width:100%">
            <el-option v-for="item in entityIdOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="filter-item" type="primary" icon="el-icon-search" style="margin-left: 10px"
            @click="handleFilter">
            搜索
          </el-button>
          <el-button class="filter-item" style="margin-left: 10px;" type="primary" icon="el-icon-edit"
            @click="handleCreate">
            新建
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <!-- 数据列表区 -->
      <el-table :data="listData" v-loading="listLoading" border highlight-current-row
        style="width: 100%;align: center;">

        <el-table-column prop="name" label="角色名称" align="center">
        </el-table-column>
        <el-table-column prop="entityName" label="所属单位" align="center">
        </el-table-column>
        <!-- <el-table-column prop="appAuthority" label="App权限" align="center" :formatter="formatAppAuthorityToName"> -->
        </el-table-column>
        <el-table-column prop="level" label="角色等级" align="center">
        </el-table-column>
        <el-table-column prop="recordStatusStr" label="标志位" align="center">
        </el-table-column>
        <el-table-column prop="operator" label="操作" width="200" align="center">
          <template v-slot:="{row,$index}">
            <span v-if="row.entityId==0">共享角色暂无操作</span>
            <el-button type="primary" size="mini" @click="handleEdite(row)" v-if="row.entityId!=0">
              编辑
            </el-button>
            <el-button type="danger" size="mini" @click="handleDelete(row)" v-if="row.entityId!=0">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页栏 -->
      <pagination :total="totalCounts" @pagination="handlePageChange">
      </pagination>
    </div>
    <!-- 新建用户dialog -->
    <el-dialog :title="dialog_title" :visible.sync="roleDialog"  >
      <el-form :model="role" ref="role" label-position="right" label-width="80px">
        <el-form-item label="角色名称">
          <el-input v-model="role.name" placeholder="请输入角色名称" maxlength="20"
            onkeyup="this.value=this.value.replace(/[^a-zA-Z\u4e00-\u9fa5]+$/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="所属单位" prop="entityId">
          <el-select v-model="role.entityId" placeholder="请选择所属单位" style="width:100%" :disabled="enbleSelect">
            <el-option v-for="item in entityIdOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="App权限" prop="appAuthority">
          <el-select v-model="role.appAuthority" placeholder="请选择角色App操作权限" style="width:100%">
            <el-option v-for="(value,key) in appAuthorityOptions" :key="key" :label="value" :value="key">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="角色等级">
          <el-input v-model="role.level" placeholder="请输入角色等级" maxlength="20" max="8"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="roleDialog = false">取 消</el-button>
        <el-button type="primary" @click="confirm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getRoles,
    roleList,
    addRole,
    updateRole,
    deleteRole
  } from '@/api/role'
  import Pagination from '@/components/common/Pagination'

  export default {
    name: 'RoleManage',
    components: {
      Pagination,
    },
    data() {
      return {
        listLoading: true,
        listData: [],
        totalCounts: 0,
        listQuery: {
          entityId: undefined, //this.$store.getters['user/entityId']
          pageIndex: 1,
          pageSize: 10,
          params: {
            name: undefined,
            // entityId: undefined,
          },
          fuzzySearch: true
        },
        entityIdOptions: [],
        entitys: {},
        //App操作权限选项//固定
        // appAuthorityOptions: {
        //   0:"无权限",
        //   1:"普通用户",
        //   2:"管理员权限",
        //   3:"超级管理员权限"
        // },
        role: {
          id: 0,
          name: '',
          level: 0,
          entityId: undefined,
          // appAuthority: undefined
        },
        dialog_title: '',
        roleDialog: false,
        enbleSelect: true,
      }
    },
    methods: {
      initEntities() {
        this.entitys = JSON.parse(localStorage.entity)
        for (let k in this.entitys) {
          this.entityIdOptions.push({
            value: parseInt(k),
            label: this.entitys[k]
          })
        }
        this.listQuery.entityId = this.entityIdOptions[0].value
        this.handleFilter()
      },
      handleFilter() {
        this.listLoading = true
        if (this.listQuery.params.name == "") this.listQuery.params.name = undefined
        roleList(this.listQuery).then(res => {
          let data = res.pageData
          this.totalCounts = data.totalCounts
          // 对后端数据进行解析
          this.listData = data.datas.map(item => {


            if (item.entityId != 0)
              item.entityName = this.entitys[item.entityId];
            else item.entityName = "共享"
            item.recordStatusStr = item.recordStatus == 1 ? "正常" : "删除";

            return item;
          })
          console.log(this.listData)
          this.listLoading = false
        })
      },
      // formatAppAuthorityToName(row) {
      //   if(row.appAuthority in this.appAuthorityOptions) 
      //     return this.appAuthorityOptions[row.appAuthority];
      //   return "未知权限";
      // },

      /**
       * @param {Object} done
       * 点击新建框外提示
       */
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      handleCreate() {
        this.dialog_title = "新建角色"
        this.role.id = 0
        this.role.name = ''
        this.role.entityId = this.listQuery.entityId
        this.roleDialog = true
        this.enbleSelect = false
        this.role.level = 0
        // this.role.appAuthority = undefined
      },
      handleEdite(row) {
        this.dialog_title = "编辑角色"
        this.role.id = row.id
        this.role.name = row.name
        this.role.level = row.level
        this.role.entityId = row.entityId
        this.roleDialog = true
        this.enbleSelect = true
        // this.role.appAuthority = row.appAuthority+""
        
      },
      handleDelete(row) {
        this.$confirm("确认删除" + row.name, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteRole(row.id).then(res => {
            if (res.result === "0") {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.handleFilter()
            } else {
              this.$message.error(res.message)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
      confirm() {
        if (!this.enbleSelect) {
          //新建
          if (this.role.name == "" || this.role.name == " ") {
            this.$message({
              message: "角色名不能为空",
              type: 'info'
            })
            return
          }
          if (this.role.entityId == undefined) {
            this.$message({
              message: "选择一个单位",
              type: 'info'
            })
            return
          }

          // if (this.role.appAuthority == undefined ) {
          //   this.$message({
          //     message: "选择用户的App操作权限",
          //     type: 'info'
          //   })
          //   return
          // }

          let reg = /^[1-9]$/;
          if (!reg.test(this.role.level)) {

            this.$message({
              message: "角色等级：选择输入1-9数字",
              type: 'info'
            })
            return

          }


          addRole(this.role).then(res => {
            if (res.result === "0") {
              this.$message({
                message: res.message,
                type: 'success'
              })

              this.roleDialog = false
              this.handleFilter()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          //编辑
          if (this.role.name == "" || this.role.name == " ") {
            this.$message({
              message: "角色名不能为空",
              type: 'info'
            })
            return
          }

          // if (this.role.appAuthority == undefined ) {
          //   this.$message({
          //     message: "选择用户的App操作权限",
          //     type: 'info'
          //   })
          //   return
          // }


          let reg = /^[1-9]$/;
          if (!reg.test(this.role.level)) {

            this.$message({
              message: "选择输入1-9数字",
              type: 'info'
            })
            return

          }
          updateRole(this.role).then(res => {
            if (res.result === "0") {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.handleFilter()
              this.roleDialog = false
            } else {
              this.$message.error(res.message)
            }
          })
        }
      },
      handlePageChange(data) {
        this.listQuery.pageIndex = data.page
        this.listQuery.pageSize = data.limit
        this.handleFilter()
      },
    },
    mounted() {
      this.initEntities()
    }
  }
</script>

<style>


</style>
